import Model from 'flarum/Model';

export default class Email extends Model {
    email = Model.attribute('email');
}
